// global.API_VERSION = 'api/'
global.API_VERSION = ''
// global.DOMAIN = 'https://101.251.222.235:8092/'
// global.DOMAIN = 'https://127.0.0.1:8000/'
// global.DOMAIN = 'https://127.0.0.1:8000/'
// global.DOMAIN = 'https://api2.zidouchat.com/'

const product_api = 'https://api2.zidouchat.com/'
const test_api = 'https://api.zidouzone.com/'

function getDomain () {
  let href = window.location.href
  if (href.indexOf('localhost') > -1 || href.indexOf('zidouzone') > -1) {
    return test_api
  } else if (href.indexOf('zidouchat') > -1) {
    return product_api
  }
}

function getLocation () {
  return `https://${window.location.hostname}`
}

global.DOMAIN = getDomain()
global.LOCATION = getLocation()

global.modules = {
  zidou: {
    assistant: '小助手列表',
    moments: '发朋友圈',
    'friend-welcome': '新好友应答', // 非正常名字= =
    private_chat: '私聊群发（企微专用）',
    private_auto_reply: '私聊自动回复（企微专用）',
    statis: '数据分析',
    share_task: '链接追踪',
    analyse: '舆情分析',
    fisson: '老客拉新',
    acquisition: '永久入群二维码',
    welcome: '入群欢迎语',
    channel: '入群渠道码',
    livecode: '加好友渠道码',
    sign: '签到',
    ai_reply: '智能陪聊',
    chatroom_score: '群积分',
    score_transaction: '积分交易',
    batch_sending: '群聊群发',
    announcement: '群公告',
    auto_reply: '群聊自动回复',
    ad: '广告监测',
    sensitive: '群消息监控',
    blacklist: '黑名单',
    group_zone: '群空间',
    essence: '群精华',
    employee: '业务员监控',
    remote: '远程登录',
    message_collection: '客服消息收集',
    live: '群直播',
    pay: '紫豆钱包',
    details: '社群数据',
    acquisition_new: '社群数据（新）',
    repeat_member: '重复群成员',
    staff: '团队协作',
    level: '层级管理',
  },
  yaca: {
    assistant: '小助手列表',
    moments: '发朋友圈',
    'friend-welcome': '新好友应答', // 非正常名字= =
    statis: '数据分析',
    share_task: '链接追踪',
    analyse: '舆情分析',
    fisson: '老客拉新',
    acquisition: '永久入群二维码',
    welcome: '入群欢迎语',
    channel: '入群渠道码',
    livecode: '加好友渠道码',
    sign: '签到',
    ai_reply: '智能陪聊',
    chatroom_score: '群积分',
    score_transaction: '积分交易',
    batch_sending: '群聊群发',
    announcement: '群公告',
    auto_reply: '群聊自动回复',
    ad: '广告监测',
    sensitive: '群消息监控',
    blacklist: '黑名单',
    group_zone: '群空间',
    essence: '群精华',
    coin: '实时报价',
    wallet: '钱包地址',
    employee: '业务员监控',
    remote: '远程登录',
    live: '群直播',
    pay: '紫豆钱包',
    details: '社群数据',
    repeat_member: '重复群成员',
    staff: '团队协作',
    level: '层级管理',
  },
  test: {
    assistant: '小助手列表',
    moments: '发朋友圈',
    'friend-welcome': '新好友应答', // 非正常名字= =
    private_chat: '私聊群发（企微专用）',
    private_auto_reply: '私聊自动回复（企微专用）',
    statis: '数据分析',
    share_task: '链接追踪',
    analyse: '舆情分析',
    fisson: '老客拉新',
    acquisition: '永久入群二维码',
    welcome: '入群欢迎语',
    channel: '入群渠道码',
    livecode: '加好友渠道码',
    sign: '签到',
    ai_reply: '智能陪聊',
    chatroom_score: '群积分',
    score_transaction: '积分交易',
    batch_sending: '群聊群发',
    announcement: '群公告',
    auto_reply: '群聊自动回复',
    ad: '广告监测',
    sensitive: '群消息监控',
    blacklist: '黑名单',
    group_zone: '群空间',
    essence: '群精华',
    coin: '实时报价',
    wallet: '钱包地址',
    employee: '业务员监控',
    remote: '远程登录',
    message_collection: '客服消息收集',
    live: '群直播',
    pay: '紫豆钱包',
    details: '社群数据',
    acquisition_new: '社群数据（新）',
    repeat_member: '重复群成员',
    staff: '团队协作',
    level: '层级管理',
  }
}
